import "@partials/UI/form/modules/recaptcha/recaptchaLoaderForStaticForm"; // загружаем Google reCAPTCHA
import { commonModules, commonExternalResources } from "@scripts/modules/lazy/commonModules";

// Модули, требующие первоначально загрузки Swiper
const swiperDependentModules = [
    Object.assign(
        () => import(/* webpackChunkName: "indexSwipers" */ "@partials/swipers/indexSwipers.js"),
        { requiresExternal: true }
    ),
    Object.assign(
        () => import(/* webpackChunkName: "additional-gallery" */ "@partials/additional/modal/modal.js"),
        { requiresExternal: true }
    ),
];

// Внешние ресурсы для страницы index
const indexResources = [
    ...commonExternalResources,
    {
        name: "swiper",
        type: "script",
        url: "https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js",
    }
];

// Внутренние модули страницы index
const indexModules = [
    ...commonModules,
    ...swiperDependentModules,
    // Дополнительные модули для главной страницы (без зависимостей)
    () => import(/* webpackChunkName: "scroll-up" */ "@scripts/modules/scroll-up.js"),
];

// Запуск ленивой инициализации
import(/* webpackChunkName: "lazy-init" */ "@scripts/modules/lazy/lazy-init.js")
    .then(({ initializeModules }) => {
        initializeModules(indexModules, indexResources);
    })
    .catch(error => {
        console.error("❌ Не удалось загрузить систему инициализации:", error);
    });